import { phpRequest } from "./phpRequest";

export const removeAccountAPI = (id, email) => {
  return phpRequest.post("/account/remove", {
    id,
    email,
  });
};
